export default __webpack_public_path__ + "static/media/buzzer-pressed-blue.6be23e24.png";